module.exports = __webpack_public_path__ + "static/media/mission-timeline2017.09500108.png";